import React from 'react';

const AlreadyRegisteredSVG = () => (
  <svg
    width="97"
    height="95"
    viewBox="0 0 97 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M77.5716 3.11458C78.4483 1.91425 80.1475 1.64066 81.3673 2.50331C82.5872 3.36596 82.8652 5.03798 81.9885 6.23821L19.4284 91.8854C18.5517 93.0858 16.8525 93.3593 15.6327 92.4967C14.4129 91.6341 14.1348 89.962 15.0115 88.7618L77.5716 3.11458Z"
      fill="#CC0000"
    />
    <path
      d="M67.6966 7.35376L18.5 74.7051V31.4427H37.5395C40.5443 31.4427 42.9796 29.0465 42.9796 26.0898V7.35522L67.6966 7.35376ZM78.3406 20.2966V82.2951C78.3406 85.2518 75.9054 87.6481 72.9006 87.6481H29.1439L78.3406 20.2966ZM22.3467 26.0889L37.54 11.1389V26.0889H22.3467Z"
      fill="#999999"
    />
  </svg>
);

export { AlreadyRegisteredSVG };
